import React, { useState, useEffect } from "react";
import { Subscribe } from "unstated";
import { t } from "@lingui/macro";
import { useQueryState } from "react-router-use-location-state";
import { i18n, PivotMenu } from "idc-ui-react";
// Fluent UI
import { PivotItem } from "@fluentui/react/lib/Pivot";
// Our modules
import { store } from "../../../stores/Main";
import { GroupsList, MoreLink, RolesList, Section } from "../../../components";

const RolesAndGroups = ({ store }) => {
  const { roles, rolegroups } = store.state.loggedInUser;

  const [tab, setTab] = useQueryState("tab", "roles");

  const [countRoles, setCountRoles] = useState(0);
  const [countRoleGroups, setCountRoleGroups] = useState(0);

  useEffect(() => {
    if (roles !== undefined) setCountRoles(roles.length);
    if (rolegroups !== undefined) setCountRoleGroups(rolegroups.length);
  }, [roles, rolegroups]);

  return (
    <Section slide="right">
      <PivotMenu
        selectedKey={tab}
        onLinkClick={item => setTab(item.props.itemKey)}
      >
        <PivotItem
          itemKey="roles"
          headerText={i18n._(t`Technical Roles`) + " (" + countRoles + ")"}
        >
          {roles && <RolesList roles={roles} />}
          <MoreLink link="/roles" text={i18n._(t`Explore all roles`)} />
        </PivotItem>
        <PivotItem
          itemKey="rolegroups"
          headerText={i18n._(t`Business Roles`) + " (" + countRoleGroups + ")"}
        >
          {rolegroups && <GroupsList rolegroups={rolegroups} />}
          <MoreLink link="/groups" text={i18n._(t`Explore all groups`)} />
        </PivotItem>
      </PivotMenu>
    </Section>
  );
};

const StoreWrapper = props => (
  <Subscribe to={[store]}>
    {store => <RolesAndGroups {...props} store={store} />}
  </Subscribe>
);

export default StoreWrapper;
